import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function AssignLabelIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 15.516}
      height={height || 15.516}
      viewBox="0 0 15.516 15.516"
    >
      <g data-name="Assign label">
        <g data-name="Path 10038" fill="none">
          <path
            d="M7.758 0A7.758 7.758 0 110 7.758 7.758 7.758 0 017.758 0z"
            transform="translate(-159.881 -138) translate(159.881 138)"
          />
          <path
            d="M7.758 1.6A6.165 6.165 0 001.6 7.758a6.165 6.165 0 006.158 6.158 6.165 6.165 0 006.158-6.158A6.165 6.165 0 007.758 1.6m0-1.6a7.758 7.758 0 110 15.516A7.758 7.758 0 017.758 0z"
            fill={color || "#fff"}
            transform="translate(-159.881 -138) translate(159.881 138)"
          />
        </g>
        <path
          data-name="Path 10037"
          d="M7.312-4.219H4.781V-6.75a.563.563 0 00-.562-.562h-.563a.563.563 0 00-.562.562v2.531H.562A.563.563 0 000-3.656v.562a.563.563 0 00.562.562h2.532V0a.563.563 0 00.562.562h.562A.563.563 0 004.781 0v-2.531h2.531a.563.563 0 00.562-.562v-.562a.563.563 0 00-.562-.564z"
          transform="translate(-159.881 -138) translate(163.881 149)"
          fill={color || "#fff"}
        />
      </g>
    </svg>
  );
}
